export const MESSAGES = {
  400: 'Invalid request.',
  401: 'Unauthorized.',
  404: 'Not Found.',
  500: 'Sorry, an unexpected error occurred, please try again.',
  unexpectedError: 'Sorry, an unexpected error occurred, please try again.',
  downloading: 'Wait, dowloading in progress, it may a few minutes.',
};
